// import React, { useContext, useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { FaShoppingCart, FaUser, FaEnvelope, FaMapMarkerAlt, FaCreditCard, FaTruck } from 'react-icons/fa'
// import { displayNGNCurrency } from '../../helpers/displayCurrency'
// import Context from '../../context'
// import { useSelector } from 'react-redux'
// import { summaryApi } from '../../common'
// import { toast } from 'react-toastify'
// import { useTheme } from '../../components/Theme/ThemeProvider'
// import { CheckCircle2, Lock, ArrowRight, AlertCircle } from 'lucide-react'

// function Checkout() {
//     const navigate = useNavigate()
//     const context = useContext(Context)
//     const { colors } = useTheme()
//     const userData = useSelector((state) => state?.user?.user)
    
//     const [cartData, setCartData] = useState([])
//     const [loading, setLoading] = useState(true)
//     const [processing, setProcessing] = useState(false)
//     const [shippingAddress, setShippingAddress] = useState({
//         street: '',
//         city: '',
//         state: '',
//         postalCode: '',
//         phoneNumber: '',
//         landmark: ''
//     })
//     const [paymentMethod, setPaymentMethod] = useState('')

//     const fetchCartData = async () => {
//     try {
//         const response = await fetch(summaryApi.cartList.url, {
//             method: summaryApi.cartList.method,
//             credentials: "include",
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//         const responseData = await response.json();

//         console.log('🔍 Checkout Cart API Response:', responseData); // Debug log

//         if (responseData.success) {
//             let cartData = [];
            
//             // Handle different response structures
//             if (Array.isArray(responseData.data)) {
//                 // New structure: array of cart items
//                 cartData = responseData.data.map(item => ({
//                     ...item,
//                     // Extract product details if nested
//                     productName: item.productDetails?.productName || item.productName,
//                     productPrice: item.productDetails?.productPrice || item.productPrice,
//                     productImage: item.productDetails?.productImage || item.productImage,
//                     quantity: item.quantity || 1
//                 }));
//             } else if (responseData.data && responseData.data.cartItems && responseData.data.products) {
//                 // Old structure: separate cartItems and products
//                 cartData = responseData.data.cartItems.products.map(cartItem => {
//                     const product = responseData.data.products.find(
//                         p => p._id === cartItem.productId
//                     );
//                     return {
//                         ...product,
//                         cartItemId: cartItem._id,
//                         quantity: cartItem.quantity || 1
//                     };
//                 });
//             }
            
//             setCartData(cartData);
//             console.log('🛒 Processed Cart Data:', cartData); // Debug log
//         } else {
//             setCartData([]);
//         }
//     } catch (error) {
//         console.error('Error fetching cart data:', error);
//         toast.error('Failed to load cart');
//     } finally {
//         setLoading(false)
//     }
// }

//     const calculateSubtotal = () => {
//     if (!cartData.length) return 0;
    
//     const subtotal = cartData.reduce((total, item) => {
//         // Try multiple possible price locations
//         const price = 
//             item.productDetails?.productPrice || 
//             item.productPrice || 
//             item.price || 
//             0;
        
//         const quantity = item.quantity || 1;
//         const itemTotal = price * quantity;
        
//         console.log(`💰 Item: ${item.productName || 'Unknown'}, Price: ${price}, Qty: ${quantity}, Total: ${itemTotal}`); // Debug
        
//         return total + itemTotal;
//     }, 0);
    
//     console.log('🎯 Final Subtotal:', subtotal); // Debug
//     return subtotal;
// }

//     const deliveryFee = 100;
//     const subtotal = calculateSubtotal();
//     const total = subtotal + deliveryFee;

//     const handleAddressChange = (e) => {
//         const { name, value } = e.target
//         setShippingAddress(prev => ({
//             ...prev,
//             [name]: value
//         }))
//     }

//     const handlePaymentMethod = async (method) => {        
//         if (!userData?._id) {
//             toast.error('User not logged in')
//             return
//         }

//         const requiredFields = ['street', 'city', 'state', 'postalCode', 'phoneNumber', 'landmark']
//         const missingFields = requiredFields.filter(field => !shippingAddress[field])
        
//         if (missingFields.length > 0) {
//             toast.error(`Please fill in: ${missingFields.join(', ')}`)
//             return
//         }

//         setProcessing(true);

//         const orderItems = cartData.map(product => ({
//             productId: product._id,
//             name: product.productName,
//             description: product.productDescription,
//             image: product.productImage[0],            
//             quantity: product.quantity,
//             price: product.productPrice,
//             size: product.size || 'default'
//         }))

//         const orderData = {
//             userId: userData?._id,
//             address: {
//                 street: shippingAddress.street,
//                 city: shippingAddress.city,
//                 state: shippingAddress.state,
//                 postalCode: shippingAddress.postalCode,
//                 phoneNumber: shippingAddress.phoneNumber,
//                 landmark: shippingAddress.landmark,
//                 country: shippingAddress.country || 'Nigeria'
//             },
//             email: userData?.email,
//             items: orderItems,
//             amount: total,
//             paymentMethod: method
//         }

//         const flutterData = {
//             ...orderData,
//             email: userData.email,
//             phone: shippingAddress.phoneNumber,
//             userId: {
//                 firstName: userData.firstName,
//                 lastName: userData.lastName,
//                 _id: userData._id
//             }
//         }

//         try {
//             switch (method) {
//                 case 'cod':
//                     const codResponse = await fetch(summaryApi.cod.url, {
//                         method: summaryApi.cod.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(orderData)
//                     })
//                     const codResult = await codResponse.json()
//                     if (codResult.success) {
//                         toast.success('Order placed successfully')
//                         navigate('/orders')
//                     } else {
//                         toast.error(codResult.message)
//                     }
//                     break

//                 case 'stripe':
//                     const stripeResponse = await fetch(summaryApi.stripe.url, {
//                         method: summaryApi.stripe.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(orderData)
//                     })
//                     const stripeResult = await stripeResponse.json()
//                     if (stripeResult.success) {
//                         window.location.replace(stripeResult.session_url)
//                     } else {
//                         toast.error(stripeResult.message)
//                     }
//                     break

//                 case 'flutterwave':
//                     const flwResponse = await fetch(summaryApi.flutterwave.url, {
//                         method: summaryApi.flutterwave.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(flutterData)
//                     })
//                     const flwResult = await flwResponse.json()
//                     if (flwResult.success) {
//                         toast.success('Redirecting to payment...')
//                         setTimeout(() => {
//                             window.location.href = flwResult.data.link
//                         }, 1000)
//                     } else {
//                         toast.error(flwResult.message || 'Failed to initiate payment')
//                     }
//                     break

//                 default:
//                     toast.error('Invalid payment method')
//             }
//         } catch (error) {
//             console.error('Payment error:', error)
//             toast.error(error.message)
//         } finally {
//             setProcessing(false);
//         }
//     }

//     useEffect(() => {
//         fetchCartData()
//     }, [])

//     // Loading State
//     if (loading) {
//         return (
//             <div className='min-h-screen transition-colors duration-300 mt-20' style={{ backgroundColor: colors.bg }}>
//                 <div className='container mx-auto px-4 py-12'>
//                     <div className='max-w-6xl mx-auto space-y-6'>
//                         {[...Array(3)].map((_, i) => (
//                             <div 
//                                 key={i}
//                                 className='h-24 rounded-xl animate-pulse'
//                                 style={{ backgroundColor: colors.bgSecondary }}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         )
//     }

//     return (
//         <div className='min-h-screen transition-colors duration-300 mt-20 pb-12' style={{ backgroundColor: colors.bg }}>
//             <div className='container mx-auto px-4 py-8'>
//                 <div className='max-w-6xl mx-auto'>
//                     {/* Header */}
//                     <div className='mb-12'>
//                         <div className='flex items-center gap-3 mb-4'>
//                             <FaShoppingCart size={32} style={{ color: colors.primary }} />
//                             <h1 
//                                 className='text-4xl font-black'
//                                 style={{ color: colors.text }}
//                             >
//                                 Checkout
//                             </h1>
//                         </div>
//                         <div 
//                             className='h-1 w-20 rounded-full'
//                             style={{ backgroundColor: colors.primary }}
//                         />
//                     </div>

//                     <div className='grid lg:grid-cols-3 gap-8'>
//                         {/* Main Content */}
//                         <div className='lg:col-span-2 space-y-8'>
//                             {/* Order Summary */}
//                             <div 
//     className='rounded-2xl p-6 overflow-hidden'
//     style={{
//         backgroundColor: colors.bgSecondary,
//         border: `1px solid ${colors.border}`
//     }}
// >
//     <h2 
//         className='text-2xl font-black mb-6'
//         style={{ color: colors.text }}
//     >
//         Order Items ({cartData.length})
//     </h2>
    
//     <div className='space-y-4'>
//         {cartData.map((product, idx) => {
//             // Safely extract product information
//             const productName = product.productName || product.productDetails?.productName || 'Unknown Product';
//             const productPrice = product.productPrice || product.productDetails?.productPrice || 0;
//             const quantity = product.quantity || 1;
//             const image = (product.productImage || product.productDetails?.productImage || [])[0] || '';
            
//             return (
//                 <div
//                     key={product._id || idx}
//                     className='flex gap-4 p-4 rounded-lg transition-all hover:shadow-lg'
//                     style={{
//                         backgroundColor: colors.bgTertiary,
//                         border: `1px solid ${colors.border}`,
//                         animation: `slideIn 0.3s ease-out ${idx * 0.05}s both`
//                     }}
//                 >
//                     <img 
//                         src={image} 
//                         alt={productName} 
//                         className='w-20 h-20 object-cover rounded-lg'
//                         style={{ backgroundColor: colors.bg }}
//                     />
//                     <div className='flex-grow'>
//                         <h3 
//                             className='font-bold line-clamp-2'
//                             style={{ color: colors.text }}
//                         >
//                             {productName}
//                         </h3>
//                         <p 
//                             className='text-sm'
//                             style={{ color: colors.textSecondary }}
//                         >
//                             Qty: {quantity}
//                         </p>
//                         <p 
//                             className='text-sm font-bold'
//                             style={{ color: colors.primary }}
//                         >
//                             Price: {displayNGNCurrency(productPrice)} each
//                         </p>
//                     </div>
//                     <div className='text-right'>
//                         <p 
//                             className='font-bold text-lg'
//                             style={{ color: colors.primary }}
//                         >
//                             {displayNGNCurrency(productPrice * quantity)}
//                         </p>
//                     </div>
//                 </div>
//             );
//         })}
//     </div>
// </div>

//                             {/* Customer Details */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 
//                                     className='text-2xl font-black mb-6'
//                                     style={{ color: colors.text }}
//                                 >
//                                     Your Information
//                                 </h2>

//                                 <div className='grid md:grid-cols-2 gap-4 mb-6'>
//                                     <div 
//                                         className='p-4 rounded-lg flex items-center gap-3'
//                                         style={{
//                                             backgroundColor: colors.bgTertiary,
//                                             border: `1px solid ${colors.border}`
//                                         }}
//                                     >
//                                         <FaUser size={20} style={{ color: colors.primary }} />
//                                         <div>
//                                             <p 
//                                                 className='text-xs'
//                                                 style={{ color: colors.textSecondary }}
//                                             >
//                                                 Name
//                                             </p>
//                                             <p 
//                                                 className='font-bold'
//                                                 style={{ color: colors.text }}
//                                             >
//                                                 {userData?.firstName} {userData?.lastName}
//                                             </p>
//                                         </div>
//                                     </div>
                                    
//                                     <div 
//                                         className='p-4 rounded-lg flex items-center gap-3'
//                                         style={{
//                                             backgroundColor: colors.bgTertiary,
//                                             border: `1px solid ${colors.border}`
//                                         }}
//                                     >
//                                         <FaEnvelope size={20} style={{ color: colors.accent }} />
//                                         <div>
//                                             <p 
//                                                 className='text-xs'
//                                                 style={{ color: colors.textSecondary }}
//                                             >
//                                                 Email
//                                             </p>
//                                             <p 
//                                                 className='font-bold text-sm'
//                                                 style={{ color: colors.text }}
//                                             >
//                                                 {userData?.email}
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Shipping Address */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 
//                                     className='text-2xl font-black mb-6 flex items-center gap-2'
//                                     style={{ color: colors.text }}
//                                 >
//                                     <FaMapMarkerAlt /> Shipping Address
//                                 </h2>

//                                 <div className='grid md:grid-cols-2 gap-4'>
//                                     {[
//                                         { name: 'street', label: 'Street Address', type: 'text' },
//                                         { name: 'city', label: 'City', type: 'text' },
//                                         { name: 'state', label: 'State', type: 'text' },
//                                         { name: 'postalCode', label: 'Postal Code', type: 'text' },
//                                         { name: 'phoneNumber', label: 'Phone Number', type: 'tel' },
//                                         { name: 'landmark', label: 'Landmark', type: 'text' }
//                                     ].map((field) => (
//                                         <input 
//                                             key={field.name}
//                                             type={field.type}
//                                             name={field.name}
//                                             placeholder={field.label}
//                                             value={shippingAddress[field.name]}
//                                             onChange={handleAddressChange}
//                                             className='w-full px-4 py-3 rounded-lg outline-none transition-all focus:scale-105'
//                                             style={{
//                                                 backgroundColor: colors.bgTertiary,
//                                                 color: colors.text,
//                                                 border: `2px solid ${colors.border}`,
//                                                 fontSize: '16px'
//                                             }}
//                                             onFocus={(e) => {
//                                                 e.target.style.borderColor = colors.primary;
//                                                 e.target.style.boxShadow = `0 0 0 3px ${colors.primaryLight}`;
//                                             }}
//                                             onBlur={(e) => {
//                                                 e.target.style.borderColor = colors.border;
//                                                 e.target.style.boxShadow = 'none';
//                                             }}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* Payment Methods */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 
//                                     className='text-2xl font-black mb-6 flex items-center gap-2'
//                                     style={{ color: colors.text }}
//                                 >
//                                     <FaCreditCard /> Payment Method
//                                 </h2>

//                                 <div className='grid md:grid-cols-3 gap-4'>
//                                     {[
//                                         { id: 'flutterwave', label: 'Flutterwave', icon: '💳', gradient: 'from-blue-600 to-blue-700' },
//                                         { id: 'stripe', label: 'Stripe', icon: '🔐', gradient: 'from-purple-600 to-purple-700' },
//                                         { id: 'cod', label: 'Cash on Delivery', icon: '🚚', gradient: 'from-green-600 to-green-700' }
//                                     ].map((method) => (
//                                         <button
//                                             key={method.id}
//                                             onClick={() => handlePaymentMethod(method.id)}
//                                             disabled={processing}
//                                             className={`p-4 rounded-xl text-white font-bold transition-all hover:scale-105 hover:shadow-lg disabled:opacity-50 flex flex-col items-center gap-2 ${
//                                                 processing ? 'cursor-not-allowed' : 'cursor-pointer'
//                                             }`}
//                                             style={{
//                                                 background: `linear-gradient(135deg, var(--grad-from) 0%, var(--grad-to) 100%)`,
//                                                 '--grad-from': method.gradient.split(' ')[1],
//                                                 '--grad-to': method.gradient.split(' ')[3]
//                                             }}
//                                         >
//                                             <span className='text-3xl'>{method.icon}</span>
//                                             {method.label}
//                                             {processing && <span className='text-xs'>Processing...</span>}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Order Summary Sidebar */}
//                         <div className='lg:col-span-1'>
//                             <div 
//                                 className='rounded-2xl p-6 sticky top-32 transition-all'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `2px solid ${colors.primary}`
//                                 }}
//                             >
//                                 <h3 
//                                     className='text-2xl font-black mb-6'
//                                     style={{ color: colors.text }}
//                                 >
//                                     Order Total
//                                 </h3>

//                                 <div className='space-y-4 mb-6'>
//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Subtotal</span>
//                                         <span 
//                                             className='font-bold'
//                                             style={{ color: colors.text }}
//                                         >
//                                             {displayNGNCurrency(subtotal)}
//                                         </span>
//                                     </div>

//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Delivery</span>
//                                         <span 
//                                             className='font-bold'
//                                             style={{ color: colors.accent }}
//                                         >
//                                             {displayNGNCurrency(deliveryFee)}
//                                         </span>
//                                     </div>

//                                     <div style={{ borderTop: `1px solid ${colors.border}` }} />

//                                     <div className='flex justify-between text-lg'>
//                                         <span 
//                                             className='font-black'
//                                             style={{ color: colors.text }}
//                                         >
//                                             Total:
//                                         </span>
//                                         <span 
//                                             className='font-black'
//                                             style={{ color: colors.primary }}
//                                         >
//                                             {displayNGNCurrency(total)}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* Security Info */}
//                                 <div 
//                                     className='p-4 rounded-lg mb-6 flex items-start gap-3'
//                                     style={{
//                                         backgroundColor: `${colors.primary}10`,
//                                         border: `1px solid ${colors.primary}30`
//                                     }}
//                                 >
//                                     <Lock size={20} style={{ color: colors.primary }} className='flex-shrink-0 mt-1' />
//                                     <div className='text-sm' style={{ color: colors.textSecondary }}>
//                                         Your payment is secure and encrypted
//                                     </div>
//                                 </div>

//                                 {/* Info Box */}
//                                 <div 
//                                     className='p-4 rounded-lg'
//                                     style={{
//                                         backgroundColor: colors.bgTertiary,
//                                         border: `1px solid ${colors.border}`
//                                     }}
//                                 >
//                                     <p className='text-xs' style={{ color: colors.textSecondary }}>
//                                         ✓ Fast Delivery
//                                         <br />✓ Easy Returns
//                                         <br />✓ 24/7 Support
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style jsx>{`
//                 @keyframes slideIn {
//                     from {
//                         opacity: 0;
//                         transform: translateX(-20px);
//                     }
//                     to {
//                         opacity: 1;
//                         transform: translateX(0);
//                     }
//                 }
//             `}</style>
//         </div>
//     )
// }

// export default Checkout


// import React, { useContext, useState, useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { FaShoppingCart, FaUser, FaEnvelope, FaMapMarkerAlt, FaCreditCard, FaGift } from 'react-icons/fa'
// import { displayNGNCurrency } from '../../helpers/displayCurrency'
// import Context from '../../context'
// import { useSelector } from 'react-redux'
// import { summaryApi } from '../../common'
// import { toast } from 'react-toastify'
// import { useTheme } from '../../components/Theme/ThemeProvider'
// import {  Lock, AlertCircle, X, Check } from 'lucide-react'

// function Checkout() {
//     const navigate = useNavigate()
//     const context = useContext(Context)
//     const { colors } = useTheme()
//     const userData = useSelector((state) => state?.user?.user)
    
//     const [cartData, setCartData] = useState([])
//     const [loading, setLoading] = useState(true)
//     const [processing, setProcessing] = useState(false)
//     const [shippingAddress, setShippingAddress] = useState({
//         street: '',
//         city: '',
//         state: '',
//         postalCode: '',
//         phoneNumber: '',
//         landmark: ''
//     })
//     const [paymentMethod, setPaymentMethod] = useState('')
    
//     // ===== NEW GIFT CARD STATE =====
//     const [giftCardCode, setGiftCardCode] = useState('')
//     const [appliedGiftCard, setAppliedGiftCard] = useState(null)
//     const [giftCardLoading, setGiftCardLoading] = useState(false)
//     const [giftCardError, setGiftCardError] = useState('')
//     // ================================

//     const fetchCartData = async () => {
//         try {
//             const response = await fetch(summaryApi.cartList.url, {
//                 method: summaryApi.cartList.method,
//                 credentials: "include",
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });
//             const responseData = await response.json();

//             if (responseData.success) {
//                 let cartData = [];
                
//                 if (Array.isArray(responseData.data)) {
//                     cartData = responseData.data.map(item => ({
//                         ...item,
//                         productName: item.productDetails?.productName || item.productName,
//                         productPrice: item.productDetails?.productPrice || item.productPrice,
//                         productImage: item.productDetails?.productImage || item.productImage,
//                         quantity: item.quantity || 1
//                     }));
//                 } else if (responseData.data && responseData.data.cartItems && responseData.data.products) {
//                     cartData = responseData.data.cartItems.products.map(cartItem => {
//                         const product = responseData.data.products.find(
//                             p => p._id === cartItem.productId
//                         );
//                         return {
//                             ...product,
//                             cartItemId: cartItem._id,
//                             quantity: cartItem.quantity || 1
//                         };
//                     });
//                 }
                
//                 setCartData(cartData);
//             } else {
//                 setCartData([]);
//             }
//         } catch (error) {
//             console.error('Error fetching cart data:', error);
//             toast.error('Failed to load cart');
//         } finally {
//             setLoading(false)
//         }
//     }

//     const calculateSubtotal = () => {
//         if (!cartData.length) return 0;
        
//         return cartData.reduce((total, item) => {
//             const price = 
//                 item.productDetails?.productPrice || 
//                 item.productPrice || 
//                 item.price || 
//                 0;
//             const quantity = item.quantity || 1;
//             return total + (price * quantity);
//         }, 0);
//     }

//     const deliveryFee = 100;
//     const subtotal = calculateSubtotal();
//     const totalBeforeDiscount = subtotal + deliveryFee;
    
//     // Calculate final total with gift card discount
//     const giftCardDiscount = appliedGiftCard?.applicableAmount || 0;
//     const finalTotal = totalBeforeDiscount - giftCardDiscount;

//     const handleAddressChange = (e) => {
//         const { name, value } = e.target
//         setShippingAddress(prev => ({
//             ...prev,
//             [name]: value
//         }))
//     }

//     // ===== NEW GIFT CARD FUNCTIONS =====
//     const validateGiftCard = async () => {
//         if (!giftCardCode.trim()) {
//             setGiftCardError('Please enter a gift card code');
//             return;
//         }

//         setGiftCardLoading(true);
//         setGiftCardError('');

//         try {
//             const response = await fetch(summaryApi.validateGiftCard.url, {
//                 method: summaryApi.validateGiftCard.method,
//                 credentials: 'include',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': `Bearer ${localStorage.getItem('token')}`
//                 },
//                 body: JSON.stringify({
//                     code: giftCardCode,
//                     orderAmount: totalBeforeDiscount
//                 })
//             });

//             const data = await response.json();

//             if (data.success && data.valid) {
//                 setAppliedGiftCard(data.data);
//                 toast.success(`Gift card applied! You saved ${displayNGNCurrency(data.data.applicableAmount)}`);
//             } else {
//                 setGiftCardError(data.message || 'Invalid gift card code');
//                 setAppliedGiftCard(null);
//             }
//         } catch (err) {
//             setGiftCardError('Failed to validate gift card');
//             setAppliedGiftCard(null);
//         } finally {
//             setGiftCardLoading(false);
//         }
//     };

//     const removeGiftCard = () => {
//         setAppliedGiftCard(null);
//         setGiftCardCode('');
//         setGiftCardError('');
//         toast.info('Gift card removed');
//     };
//     // ===================================

//     const handlePaymentMethod = async (method) => {        
//         if (!userData?._id) {
//             toast.error('User not logged in')
//             return
//         }

//         const requiredFields = ['street', 'city', 'state', 'postalCode', 'phoneNumber', 'landmark']
//         const missingFields = requiredFields.filter(field => !shippingAddress[field])
        
//         if (missingFields.length > 0) {
//             toast.error(`Please fill in: ${missingFields.join(', ')}`)
//             return
//         }

//         setProcessing(true);

//         const orderItems = cartData.map(product => ({
//             productId: product._id,
//             name: product.productName,
//             description: product.productDescription,
//             image: product.productImage[0],            
//             quantity: product.quantity,
//             price: product.productPrice,
//             size: product.size || 'default'
//         }))

//         const orderData = {
//             userId: userData?._id,
//             address: {
//                 street: shippingAddress.street,
//                 city: shippingAddress.city,
//                 state: shippingAddress.state,
//                 postalCode: shippingAddress.postalCode,
//                 phoneNumber: shippingAddress.phoneNumber,
//                 landmark: shippingAddress.landmark,
//                 country: shippingAddress.country || 'Nigeria'
//             },
//             email: userData?.email,
//             items: orderItems,
//             amount: totalBeforeDiscount,
//             paymentMethod: method,
//             // ===== ADD GIFT CARD TO ORDER =====
//             giftCardCode: appliedGiftCard?.code || null
//             // ==================================
//         }

//         const flutterData = {
//             ...orderData,
//             email: userData.email,
//             phone: shippingAddress.phoneNumber,
//             userId: {
//                 firstName: userData.firstName,
//                 lastName: userData.lastName,
//                 _id: userData._id
//             }
//         }

//         try {
//             switch (method) {
//                 case 'cod':
//                     const codResponse = await fetch(summaryApi.cod.url, {
//                         method: summaryApi.cod.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(orderData)
//                     })
//                     const codResult = await codResponse.json()
//                     if (codResult.success) {
//                         toast.success('Order placed successfully')
//                         navigate('/orders')
//                     } else {
//                         toast.error(codResult.message)
//                     }
//                     break

//                 case 'stripe':
//                     const stripeResponse = await fetch(summaryApi.stripe.url, {
//                         method: summaryApi.stripe.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(orderData)
//                     })
//                     const stripeResult = await stripeResponse.json()
//                     if (stripeResult.success) {
//                         window.location.replace(stripeResult.session_url)
//                     } else {
//                         toast.error(stripeResult.message)
//                     }
//                     break

//                 case 'flutterwave':
//                     const flwResponse = await fetch(summaryApi.flutterwave.url, {
//                         method: summaryApi.flutterwave.method,
//                         credentials: 'include',
//                         headers: {
//                             'Content-Type': 'application/json',
//                         },
//                         body: JSON.stringify(flutterData)
//                     })
//                     const flwResult = await flwResponse.json()
//                     if (flwResult.success) {
//                         toast.success('Redirecting to payment...')
//                         setTimeout(() => {
//                             window.location.href = flwResult.data.link
//                         }, 1000)
//                     } else {
//                         toast.error(flwResult.message || 'Failed to initiate payment')
//                     }
//                     break

//                 default:
//                     toast.error('Invalid payment method')
//             }
//         } catch (error) {
//             console.error('Payment error:', error)
//             toast.error(error.message)
//         } finally {
//             setProcessing(false);
//         }
//     }

//     useEffect(() => {
//         fetchCartData()
//     }, [])

//     if (loading) {
//         return (
//             <div className='min-h-screen transition-colors duration-300 mt-20' style={{ backgroundColor: colors.bg }}>
//                 <div className='container mx-auto px-4 py-12'>
//                     <div className='max-w-6xl mx-auto space-y-6'>
//                         {[...Array(3)].map((_, i) => (
//                             <div 
//                                 key={i}
//                                 className='h-24 rounded-xl animate-pulse'
//                                 style={{ backgroundColor: colors.bgSecondary }}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         )
//     }

//     return (
//         <div className='min-h-screen transition-colors duration-300 mt-20 pb-12' style={{ backgroundColor: colors.bg }}>
//             <div className='container mx-auto px-4 py-8'>
//                 <div className='max-w-6xl mx-auto'>
//                     {/* Header */}
//                     <div className='mb-12'>
//                         <div className='flex items-center gap-3 mb-4'>
//                             <FaShoppingCart size={32} style={{ color: colors.primary }} />
//                             <h1 className='text-4xl font-black' style={{ color: colors.text }}>
//                                 Checkout
//                             </h1>
//                         </div>
//                         <div className='h-1 w-20 rounded-full' style={{ backgroundColor: colors.primary }} />
//                     </div>

//                     <div className='grid lg:grid-cols-3 gap-8'>
//                         {/* Main Content */}
//                         <div className='lg:col-span-2 space-y-8'>
//                             {/* Order Summary */}
//                             <div 
//                                 className='rounded-2xl p-6 overflow-hidden'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 className='text-2xl font-black mb-6' style={{ color: colors.text }}>
//                                     Order Items ({cartData.length})
//                                 </h2>
                                
//                                 <div className='space-y-4'>
//                                     {cartData.map((product, idx) => {
//                                         const productName = product.productName || product.productDetails?.productName || 'Unknown Product';
//                                         const productPrice = product.productPrice || product.productDetails?.productPrice || 0;
//                                         const quantity = product.quantity || 1;
//                                         const image = (product.productImage || product.productDetails?.productImage || [])[0] || '';
                                        
//                                         return (
//                                             <div
//                                                 key={product._id || idx}
//                                                 className='flex gap-4 p-4 rounded-lg transition-all hover:shadow-lg'
//                                                 style={{
//                                                     backgroundColor: colors.bgTertiary,
//                                                     border: `1px solid ${colors.border}`
//                                                 }}
//                                             >
//                                                 <img 
//                                                     src={image} 
//                                                     alt={productName} 
//                                                     className='w-20 h-20 object-cover rounded-lg'
//                                                     style={{ backgroundColor: colors.bg }}
//                                                 />
//                                                 <div className='flex-grow'>
//                                                     <h3 className='font-bold line-clamp-2' style={{ color: colors.text }}>
//                                                         {productName}
//                                                     </h3>
//                                                     <p className='text-sm' style={{ color: colors.textSecondary }}>
//                                                         Qty: {quantity}
//                                                     </p>
//                                                     <p className='text-sm font-bold' style={{ color: colors.primary }}>
//                                                         Price: {displayNGNCurrency(productPrice)} each
//                                                     </p>
//                                                 </div>
//                                                 <div className='text-right'>
//                                                     <p className='font-bold text-lg' style={{ color: colors.primary }}>
//                                                         {displayNGNCurrency(productPrice * quantity)}
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                         );
//                                     })}
//                                 </div>
//                             </div>

//                             {/* Customer Details */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 className='text-2xl font-black mb-6' style={{ color: colors.text }}>
//                                     Your Information
//                                 </h2>

//                                 <div className='grid md:grid-cols-2 gap-4 mb-6'>
//                                     <div 
//                                         className='p-4 rounded-lg flex items-center gap-3'
//                                         style={{
//                                             backgroundColor: colors.bgTertiary,
//                                             border: `1px solid ${colors.border}`
//                                         }}
//                                     >
//                                         <FaUser size={20} style={{ color: colors.primary }} />
//                                         <div>
//                                             <p className='text-xs' style={{ color: colors.textSecondary }}>Name</p>
//                                             <p className='font-bold' style={{ color: colors.text }}>
//                                                 {userData?.firstName} {userData?.lastName}
//                                             </p>
//                                         </div>
//                                     </div>
                                    
//                                     <div 
//                                         className='p-4 rounded-lg flex items-center gap-3'
//                                         style={{
//                                             backgroundColor: colors.bgTertiary,
//                                             border: `1px solid ${colors.border}`
//                                         }}
//                                     >
//                                         <FaEnvelope size={20} style={{ color: colors.accent }} />
//                                         <div>
//                                             <p className='text-xs' style={{ color: colors.textSecondary }}>Email</p>
//                                             <p className='font-bold text-sm' style={{ color: colors.text }}>
//                                                 {userData?.email}
//                                             </p>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Shipping Address */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 className='text-2xl font-black mb-6 flex items-center gap-2' style={{ color: colors.text }}>
//                                     <FaMapMarkerAlt /> Shipping Address
//                                 </h2>

//                                 <div className='grid md:grid-cols-2 gap-4'>
//                                     {[
//                                         { name: 'street', label: 'Street Address', type: 'text' },
//                                         { name: 'city', label: 'City', type: 'text' },
//                                         { name: 'state', label: 'State', type: 'text' },
//                                         { name: 'postalCode', label: 'Postal Code', type: 'text' },
//                                         { name: 'phoneNumber', label: 'Phone Number', type: 'tel' },
//                                         { name: 'landmark', label: 'Landmark', type: 'text' }
//                                     ].map((field) => (
//                                         <input 
//                                             key={field.name}
//                                             type={field.type}
//                                             name={field.name}
//                                             placeholder={field.label}
//                                             value={shippingAddress[field.name]}
//                                             onChange={handleAddressChange}
//                                             className='w-full px-4 py-3 rounded-lg outline-none transition-all focus:scale-105'
//                                             style={{
//                                                 backgroundColor: colors.bgTertiary,
//                                                 color: colors.text,
//                                                 border: `2px solid ${colors.border}`,
//                                                 fontSize: '16px'
//                                             }}
//                                             onFocus={(e) => {
//                                                 e.target.style.borderColor = colors.primary;
//                                                 e.target.style.boxShadow = `0 0 0 3px ${colors.primaryLight}`;
//                                             }}
//                                             onBlur={(e) => {
//                                                 e.target.style.borderColor = colors.border;
//                                                 e.target.style.boxShadow = 'none';
//                                             }}
//                                         />
//                                     ))}
//                                 </div>
//                             </div>

//                             {/* ===== NEW GIFT CARD SECTION ===== */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 className='text-2xl font-black mb-6 flex items-center gap-2' style={{ color: colors.text }}>
//                                     <FaGift /> Have a Gift Card?
//                                 </h2>

//                                 {!appliedGiftCard ? (
//                                     <div>
//                                         <div className='flex gap-3 mb-3'>
//                                             <input 
//                                                 type='text'
//                                                 value={giftCardCode}
//                                                 onChange={(e) => setGiftCardCode(e.target.value.toUpperCase())}
//                                                 onKeyPress={(e) => e.key === 'Enter' && validateGiftCard()}
//                                                 placeholder='GC-XXXX-XXXX-XXXX'
//                                                 maxLength={20}
//                                                 className='flex-1 px-4 py-3 rounded-lg outline-none font-mono'
//                                                 style={{
//                                                     backgroundColor: colors.bgTertiary,
//                                                     color: colors.text,
//                                                     border: `2px solid ${colors.border}`
//                                                 }}
//                                             />
//                                             <button
//                                                 onClick={validateGiftCard}
//                                                 disabled={giftCardLoading || !giftCardCode.trim()}
//                                                 className='px-6 py-3 rounded-lg font-bold transition-all hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed'
//                                                 style={{
//                                                     backgroundColor: colors.primary,
//                                                     color: 'white'
//                                                 }}
//                                             >
//                                                 {giftCardLoading ? 'Checking...' : 'Apply'}
//                                             </button>
//                                         </div>
                                        
//                                         {giftCardError && (
//                                             <div 
//                                                 className='flex items-start gap-2 p-3 rounded-lg'
//                                                 style={{
//                                                     backgroundColor: '#fee',
//                                                     border: '1px solid #fcc'
//                                                 }}
//                                             >
//                                                 <AlertCircle className='w-4 h-4 text-red-600 mt-0.5 flex-shrink-0' />
//                                                 <p className='text-sm text-red-600'>{giftCardError}</p>
//                                             </div>
//                                         )}
//                                     </div>
//                                 ) : (
//                                     <div 
//                                         className='p-4 rounded-lg'
//                                         style={{
//                                             backgroundColor: '#d4edda',
//                                             border: '1px solid #c3e6cb'
//                                         }}
//                                     >
//                                         <div className='flex items-start justify-between mb-3'>
//                                             <div className='flex items-start gap-2'>
//                                                 <Check className='w-5 h-5 text-green-600 mt-0.5' />
//                                                 <div>
//                                                     <p className='font-bold text-green-900'>Gift Card Applied</p>
//                                                     <p className='text-sm text-green-700 font-mono mt-1'>
//                                                         {appliedGiftCard.code}
//                                                     </p>
//                                                 </div>
//                                             </div>
//                                             <button
//                                                 onClick={removeGiftCard}
//                                                 className='text-green-700 hover:text-green-900 transition'
//                                             >
//                                                 <X className='w-5 h-5' />
//                                             </button>
//                                         </div>
                                        
//                                         <div className='space-y-1 text-sm'>
//                                             <div className='flex justify-between'>
//                                                 <span className='text-gray-600'>Gift Card Balance:</span>
//                                                 <span className='font-medium'>
//                                                     {displayNGNCurrency(appliedGiftCard.currentBalance)}
//                                                 </span>
//                                             </div>
//                                             <div className='flex justify-between'>
//                                                 <span className='text-gray-600'>Applied Amount:</span>
//                                                 <span className='font-bold text-green-600'>
//                                                     -{displayNGNCurrency(appliedGiftCard.applicableAmount)}
//                                                 </span>
//                                             </div>
//                                             <div className='flex justify-between pt-2 border-t border-green-200'>
//                                                 <span className='text-gray-600'>Remaining Balance:</span>
//                                                 <span className='font-medium'>
//                                                     {displayNGNCurrency(appliedGiftCard.remainingBalance)}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                             {/* ================================== */}

//                             {/* Payment Methods */}
//                             <div 
//                                 className='rounded-2xl p-6'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `1px solid ${colors.border}`
//                                 }}
//                             >
//                                 <h2 className='text-2xl font-black mb-6 flex items-center gap-2' style={{ color: colors.text }}>
//                                     <FaCreditCard /> Payment Method
//                                 </h2>

//                                 <div className='grid md:grid-cols-3 gap-4'>
//                                     {[
//                                         { id: 'flutterwave', label: 'Flutterwave', icon: '💳', gradient: 'from-blue-600 to-blue-700' },
//                                         { id: 'stripe', label: 'Stripe', icon: '🔐', gradient: 'from-purple-600 to-purple-700' },
//                                         { id: 'cod', label: 'Cash on Delivery', icon: '🚚', gradient: 'from-green-600 to-green-700' }
//                                     ].map((method) => (
//                                         <button
//                                             key={method.id}
//                                             onClick={() => handlePaymentMethod(method.id)}
//                                             disabled={processing}
//                                             className={`p-4 rounded-xl text-white font-bold transition-all hover:scale-105 hover:shadow-lg disabled:opacity-50 flex flex-col items-center gap-2 ${
//                                                 processing ? 'cursor-not-allowed' : 'cursor-pointer'
//                                             }`}
//                                             style={{
//                                                 background: `linear-gradient(135deg, var(--grad-from) 0%, var(--grad-to) 100%)`,
//                                                 '--grad-from': method.gradient.split(' ')[1],
//                                                 '--grad-to': method.gradient.split(' ')[3]
//                                             }}
//                                         >
//                                             <span className='text-3xl'>{method.icon}</span>
//                                             {method.label}
//                                             {processing && <span className='text-xs'>Processing...</span>}
//                                         </button>
//                                     ))}
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Order Summary Sidebar */}
//                         <div className='lg:col-span-1'>
//                             <div 
//                                 className='rounded-2xl p-6 sticky top-32 transition-all'
//                                 style={{
//                                     backgroundColor: colors.bgSecondary,
//                                     border: `2px solid ${colors.primary}`
//                                 }}
//                             >
//                                 <h3 className='text-2xl font-black mb-6' style={{ color: colors.text }}>
//                                     Order Total
//                                 </h3>

//                                 <div className='space-y-4 mb-6'>
//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Subtotal</span>
//                                         <span className='font-bold' style={{ color: colors.text }}>
//                                             {displayNGNCurrency(subtotal)}
//                                         </span>
//                                     </div>

//                                     <div className='flex justify-between text-sm'>
//                                         <span style={{ color: colors.textSecondary }}>Delivery</span>
//                                         <span className='font-bold' style={{ color: colors.accent }}>
//                                             {displayNGNCurrency(deliveryFee)}
//                                         </span>
//                                     </div>

//                                     {/* ===== GIFT CARD DISCOUNT DISPLAY ===== */}
//                                     {appliedGiftCard && (
//                                         <div className='flex justify-between text-sm'>
//                                             <span style={{ color: colors.textSecondary }}>
//                                                 Gift Card Discount
//                                             </span>
//                                             <span className='font-bold text-green-600'>
//                                                 -{displayNGNCurrency(giftCardDiscount)}
//                                             </span>
//                                         </div>
//                                     )}
//                                     {/* ======================================= */}

//                                     <div style={{ borderTop: `1px solid ${colors.border}` }} />

//                                     <div className='flex justify-between text-lg'>
//                                         <span className='font-black' style={{ color: colors.text }}>
//                                             Total:
//                                         </span>
//                                         <span className='font-black' style={{ color: colors.primary }}>
//                                             {displayNGNCurrency(finalTotal)}
//                                         </span>
//                                     </div>
                                    
//                                     {/* ===== SAVINGS INDICATOR ===== */}
//                                     {appliedGiftCard && (
//                                         <div 
//                                             className='p-3 rounded-lg text-center'
//                                             style={{
//                                                 backgroundColor: '#d4edda',
//                                                 border: '1px solid #c3e6cb'
//                                             }}
//                                         >
//                                             <p className='text-sm font-bold text-green-800'>
//                                                 🎉 You saved {displayNGNCurrency(giftCardDiscount)}!
//                                             </p>
//                                         </div>
//                                     )}
//                                     {/* ============================== */}
//                                 </div>

//                                 {/* Security Info */}
//                                 <div 
//                                     className='p-4 rounded-lg mb-6 flex items-start gap-3'
//                                     style={{
//                                         backgroundColor: `${colors.primary}10`,
//                                         border: `1px solid ${colors.primary}30`
//                                     }}
//                                 >
//                                     <Lock size={20} style={{ color: colors.primary }} className='flex-shrink-0 mt-1' />
//                                     <div className='text-sm' style={{ color: colors.textSecondary }}>
//                                         Your payment is secure and encrypted
//                                     </div>
//                                 </div>

//                                 {/* Info Box */}
//                                 <div 
//                                     className='p-4 rounded-lg'
//                                     style={{
//                                         backgroundColor: colors.bgTertiary,
//                                         border: `1px solid ${colors.border}`
//                                     }}
//                                 >
//                                     <p className='text-xs' style={{ color: colors.textSecondary }}>
//                                         ✓ Fast Delivery
//                                         <br />✓ Easy Returns
//                                         <br />✓ 24/7 Support
//                                         {appliedGiftCard && (
//                                             <>
//                                                 <br />✓ Gift Card Applied
//                                             </>
//                                         )}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <style jsx>{`
//                 @keyframes slideIn {
//                     from {
//                         opacity: 0;
//                         transform: translateX(-20px);
//                     }
//                     to {
//                         opacity: 1;
//                         transform: translateX(0);
//                     }
//                 }
//             `}</style>
//         </div>
//     )
// }

// export default Checkout;





import React, { useContext, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FaShoppingCart, FaUser, FaEnvelope, FaMapMarkerAlt, FaCreditCard, FaGift } from 'react-icons/fa'
import { displayNGNCurrency } from '../../helpers/displayCurrency'
import Context from '../../context'
import { useSelector } from 'react-redux'
import { summaryApi } from '../../common'
import { toast } from 'react-toastify'
import { Lock, AlertCircle, X, Check, ArrowRight, Package, Shield, Truck } from 'lucide-react'
import { authFetch } from '../../helpers/authFetch';

function Checkout() {
    const navigate = useNavigate()
    const context = useContext(Context)
    const userData = useSelector((state) => state?.user?.user)
    
    const [cartData, setCartData] = useState([])
    const [loading, setLoading] = useState(true)
    const [processing, setProcessing] = useState(false)
    const [shippingAddress, setShippingAddress] = useState({
        street: '',
        city: '',
        state: '',
        postalCode: '',
        phoneNumber: '',
        landmark: ''
    })
    const [paymentMethod, setPaymentMethod] = useState('')
    
    // Gift Card State
    const [giftCardCode, setGiftCardCode] = useState('')
    const [appliedGiftCard, setAppliedGiftCard] = useState(null)
    const [giftCardLoading, setGiftCardLoading] = useState(false)
    const [giftCardError, setGiftCardError] = useState('')

    // Elegant color palette
    const colors = {
        primary: '#1a365d', // Elegant dark blue
        accent: '#7c3aed', // Elegant purple
        bg: '#fafafa', // Light background
        bgSecondary: '#ffffff', // White background
        bgTertiary: '#f5f5f5', // Light gray background
        text: '#171717', // Dark text
        textSecondary: '#525252', // Medium gray text
        border: '#d4d4d4', // Light border
        shadow: 'rgba(0, 0, 0, 0.05)',
        success: '#10b981',
        error: '#dc2626'
    };

    const fetchCartData = async () => {
        try {
            const response = await authFetch(summaryApi.cartList.url, {
                method: summaryApi.cartList.method,
                
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const responseData = await response.json();

            if (responseData.success) {
                let cartData = [];
                
                if (Array.isArray(responseData.data)) {
                    cartData = responseData.data.map(item => ({
                        ...item,
                        productName: item.productDetails?.productName || item.productName,
                        productPrice: item.productDetails?.productPrice || item.productPrice,
                        productImage: item.productDetails?.productImage || item.productImage,
                        quantity: item.quantity || 1
                    }));
                } else if (responseData.data && responseData.data.cartItems && responseData.data.products) {
                    cartData = responseData.data.cartItems.products.map(cartItem => {
                        const product = responseData.data.products.find(
                            p => p._id === cartItem.productId
                        );
                        return {
                            ...product,
                            cartItemId: cartItem._id,
                            quantity: cartItem.quantity || 1
                        };
                    });
                }
                
                setCartData(cartData);
            } else {
                setCartData([]);
            }
        } catch (error) {
            console.error('Error fetching cart data:', error);
            toast.error('Failed to load cart');
        } finally {
            setLoading(false)
        }
    }

    const calculateSubtotal = () => {
        if (!cartData.length) return 0;
        
        return cartData.reduce((total, item) => {
            const price = 
                item.productDetails?.productPrice || 
                item.productPrice || 
                item.price || 
                0;
            const quantity = item.quantity || 1;
            return total + (price * quantity);
        }, 0);
    }

    const deliveryFee = 100;
    const subtotal = calculateSubtotal();
    const totalBeforeDiscount = subtotal + deliveryFee;
    
    // Calculate final total with gift card discount
    const giftCardDiscount = appliedGiftCard?.applicableAmount || 0;
    const finalTotal = totalBeforeDiscount - giftCardDiscount;

    const handleAddressChange = (e) => {
        const { name, value } = e.target
        setShippingAddress(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const validateGiftCard = async () => {
        if (!giftCardCode.trim()) {
            setGiftCardError('Please enter a gift card code');
            return;
        }

        setGiftCardLoading(true);
        setGiftCardError('');

        try {
            const response = await authFetch(summaryApi.validateGiftCard.url, {
                method: summaryApi.validateGiftCard.method,
                
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    code: giftCardCode,
                    orderAmount: totalBeforeDiscount
                })
            });

            const data = await response.json();

            if (data.success && data.valid) {
                setAppliedGiftCard(data.data);
                toast.success(`Gift card applied! You saved ${displayNGNCurrency(data.data.applicableAmount)}`);
            } else {
                setGiftCardError(data.message || 'Invalid gift card code');
                setAppliedGiftCard(null);
            }
        } catch (err) {
            setGiftCardError('Failed to validate gift card');
            setAppliedGiftCard(null);
        } finally {
            setGiftCardLoading(false);
        }
    };

    const removeGiftCard = () => {
        setAppliedGiftCard(null);
        setGiftCardCode('');
        setGiftCardError('');
        toast.info('Gift card removed');
    };

    const handlePaymentMethod = async (method) => {        
        if (!userData?._id) {
            toast.error('User not logged in')
            return
        }

        const requiredFields = ['street', 'city', 'state', 'postalCode', 'phoneNumber', 'landmark']
        const missingFields = requiredFields.filter(field => !shippingAddress[field])
        
        if (missingFields.length > 0) {
            toast.error(`Please fill in: ${missingFields.join(', ')}`)
            return
        }

        setProcessing(true);

        const orderItems = cartData.map(product => ({
            productId: product._id,
            name: product.productName,
            description: product.productDescription,
            image: product.productImage[0],            
            quantity: product.quantity,
            price: product.productPrice,
            size: product.size || 'default'
        }))

        const orderData = {
            userId: userData?._id,
            address: {
                street: shippingAddress.street,
                city: shippingAddress.city,
                state: shippingAddress.state,
                postalCode: shippingAddress.postalCode,
                phoneNumber: shippingAddress.phoneNumber,
                landmark: shippingAddress.landmark,
                country: shippingAddress.country || 'Nigeria'
            },
            email: userData?.email,
            items: orderItems,
            amount: totalBeforeDiscount,
            paymentMethod: method,
            giftCardCode: appliedGiftCard?.code || null
        }

        const flutterData = {
            ...orderData,
            email: userData.email,
            phone: shippingAddress.phoneNumber,
            userId: {
                firstName: userData.firstName,
                lastName: userData.lastName,
                _id: userData._id
            }
        }

        try {
            switch (method) {
                case 'cod':
                    const codResponse = await authFetch(summaryApi.cod.url, {
                        method: summaryApi.cod.method,
                        
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(orderData)
                    })
                    const codResult = await codResponse.json()
                    if (codResult.success) {
                        toast.success('Order placed successfully')
                        navigate('/orders')
                    } else {
                        toast.error(codResult.message)
                    }
                    break

                case 'stripe':
                    const stripeResponse = await authFetch(summaryApi.stripe.url, {
                        method: summaryApi.stripe.method,
                        
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(orderData)
                    })
                    const stripeResult = await stripeResponse.json()
                    if (stripeResult.success) {
                        window.location.replace(stripeResult.session_url)
                    } else {
                        toast.error(stripeResult.message)
                    }
                    break

                case 'flutterwave':
                    const flwResponse = await authFetch(summaryApi.flutterwave.url, {
                        method: summaryApi.flutterwave.method,
                        
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(flutterData)
                    })
                    const flwResult = await flwResponse.json()
                    if (flwResult.success) {
                        toast.success('Redirecting to payment...')
                        setTimeout(() => {
                            window.location.href = flwResult.data.link
                        }, 1000)
                    } else {
                        toast.error(flwResult.message || 'Failed to initiate payment')
                    }
                    break

                default:
                    toast.error('Invalid payment method')
            }
        } catch (error) {
            console.error('Payment error:', error)
            toast.error(error.message)
        } finally {
            setProcessing(false);
        }
    }

    useEffect(() => {
        fetchCartData()
    }, [])

    // Loading Skeleton
    if (loading) {
        return (
            <div className='min-h-screen bg-neutral-50 pt-16' style={{ fontFamily: 'Georgia, serif' }}>
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8'>
                    <div className='max-w-6xl mx-auto'>
                        {/* Header Skeleton */}
                        <div className='mb-8 sm:mb-12'>
                            <div className='h-8 sm:h-10 w-40 sm:w-48 bg-neutral-200 animate-pulse mb-3 sm:mb-4' />
                            <div className='h-px w-16 bg-neutral-300' />
                        </div>
                        
                        <div className='lg:grid lg:grid-cols-3 lg:gap-12'>
                            {/* Main Content Skeleton */}
                            <div className='lg:col-span-2 space-y-6'>
                                {[...Array(3)].map((_, i) => (
                                    <div 
                                        key={i}
                                        className='p-4 sm:p-6 rounded-lg border border-neutral-300 animate-pulse bg-neutral-100 h-48 sm:h-56'
                                    />
                                ))}
                            </div>
                            
                            {/* Sidebar Skeleton */}
                            <div className='hidden lg:block'>
                                <div className='p-6 border border-neutral-300 rounded-lg bg-neutral-100 h-64 animate-pulse' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // Empty Cart State
    if (!cartData.length) {
        return (
            <div className='min-h-screen bg-neutral-50 pt-16 flex items-center justify-center' style={{ fontFamily: 'Georgia, serif' }}>
                <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16'>
                    <div 
                        className='max-w-2xl mx-auto text-center p-6 sm:p-8 md:p-16 border border-neutral-300 bg-white rounded-lg'
                    >
                        <div className='mb-6 sm:mb-8'>
                            <Package 
                                size={60}
                                className='mx-auto text-neutral-600 mb-4 sm:mb-6'
                            />
                        </div>
                        <h2 
                            className='text-2xl sm:text-3xl font-normal mb-3 sm:mb-4 text-neutral-900 tracking-tight'
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Your Cart is Empty
                        </h2>
                        <p 
                            className='text-sm sm:text-base mb-8 sm:mb-10 text-neutral-600 leading-relaxed px-2 sm:px-0'
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            Add items to your cart to proceed with checkout.
                        </p>
                        <Link 
                            to="/cart"
                            className='inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 text-xs sm:text-sm uppercase tracking-wider text-neutral-200 font-medium transition-all hover:scale-[1.02] hover:shadow-lg bg-neutral-900 border border-neutral-900'
                            style={{ fontFamily: 'Georgia, serif' }}
                        >
                            View Cart
                            <ArrowRight size={16} />
                        </Link>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='min-h-screen bg-neutral-50 mt-[-40px] pb-12 sm:pb-16' style={{ fontFamily: 'Georgia, serif' }}>
            <div className='container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8'>
                <div className='max-w-6xl mx-auto'>
                    {/* Header */}
                    <div className='mb-8 sm:mb-12'>
                        <h1 
                            className='text-2xl sm:text-3xl lg:text-4xl font-normal mb-3 sm:mb-4 text-neutral-900 tracking-tight'
                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                        >
                            Checkout
                        </h1>
                        <div className='h-px w-16 bg-neutral-300' />
                        <p className='text-sm text-neutral-600 mt-2 sm:mt-3' style={{ fontFamily: 'Georgia, serif' }}>
                            Complete your purchase in a few simple steps
                        </p>
                    </div>

                    <div className='lg:grid lg:grid-cols-3 lg:gap-12'>
                        {/* Main Content */}
                        <div className='lg:col-span-2 space-y-6 sm:space-y-8'>
                            {/* Order Summary */}
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg'
                            >
                                <h2 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight' 
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    Order Items ({cartData.length})
                                </h2>
                                
                                <div className='space-y-3 sm:space-y-4'>
                                    {cartData.map((product, idx) => {
                                        const productName = product.productName || product.productDetails?.productName || 'Unknown Product';
                                        const productPrice = product.productPrice || product.productDetails?.productPrice || 0;
                                        const quantity = product.quantity || 1;
                                        const image = (product.productImage || product.productDetails?.productImage || [])[0] || '';
                                        
                                        return (
                                            <div
                                                key={product._id || idx}
                                                className='flex gap-3 sm:gap-4 p-3 sm:p-4 border border-neutral-300 rounded-lg'
                                            >
                                                <div className='w-16 h-16 sm:w-20 sm:h-20 bg-neutral-100 border border-neutral-300 flex items-center justify-center overflow-hidden flex-shrink-0'>
                                                    <img 
                                                        src={image} 
                                                        alt={productName} 
                                                        className='h-full w-full object-scale-down p-2'
                                                    />
                                                </div>
                                                <div className='flex-grow min-w-0'>
                                                    <div className='flex justify-between items-start'>
                                                        <div className='flex-1'>
                                                            <h3 className='font-normal text-sm sm:text-base text-neutral-900 tracking-tight line-clamp-2' 
                                                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                                {productName}
                                                            </h3>
                                                            <p className='text-xs sm:text-sm text-neutral-600 mt-1' 
                                                                style={{ fontFamily: 'Georgia, serif' }}>
                                                                Qty: {quantity}
                                                            </p>
                                                        </div>
                                                        <div className='text-right ml-2'>
                                                            <p className='font-normal text-sm sm:text-base text-neutral-900'
                                                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                                {displayNGNCurrency(productPrice)}
                                                            </p>
                                                            <p className='text-xs text-neutral-500 mt-1' 
                                                                style={{ fontFamily: 'Georgia, serif' }}>
                                                                Each
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className='mt-2 sm:mt-3 flex justify-between items-center'>
                                                        <p className='text-sm text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                            Item Total:
                                                        </p>
                                                        <p className='font-normal text-base text-neutral-900'
                                                            style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                            {displayNGNCurrency(productPrice * quantity)}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Customer Details */}
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg'
                            >
                                <h2 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    Your Information
                                </h2>

                                <div className='grid sm:grid-cols-2 gap-3 sm:gap-4'>
                                    <div 
                                        className='p-3 sm:p-4 border border-neutral-300 rounded-lg'
                                    >
                                        <div className='flex items-center gap-2 sm:gap-3'>
                                            <FaUser size={16} className='text-neutral-600' />
                                            <div>
                                                <p className='text-xs text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    Name
                                                </p>
                                                <p className='font-normal text-sm text-neutral-900 mt-1'
                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                    {userData?.firstName} {userData?.lastName}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div 
                                        className='p-3 sm:p-4 border border-neutral-300 rounded-lg'
                                    >
                                        <div className='flex items-center gap-2 sm:gap-3'>
                                            <FaEnvelope size={16} className='text-neutral-600' />
                                            <div>
                                                <p className='text-xs text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    Email
                                                </p>
                                                <p className='font-normal text-sm text-neutral-900 mt-1'
                                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                    {userData?.email}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Shipping Address */}
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg'
                            >
                                <h2 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight flex items-center gap-2'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    <FaMapMarkerAlt size={20} className='text-neutral-600' />
                                    Shipping Address
                                </h2>

                                <div className='grid sm:grid-cols-2 gap-3 sm:gap-4'>
                                    {[
                                        { name: 'street', label: 'Street Address', type: 'text' },
                                        { name: 'city', label: 'City', type: 'text' },
                                        { name: 'state', label: 'State', type: 'text' },
                                        { name: 'postalCode', label: 'Postal Code', type: 'text' },
                                        { name: 'phoneNumber', label: 'Phone Number', type: 'tel' },
                                        { name: 'landmark', label: 'Landmark', type: 'text' }
                                    ].map((field) => (
                                        <div key={field.name} className={field.name === 'street' ? 'sm:col-span-2' : ''}>
                                            <input 
                                                type={field.type}
                                                name={field.name}
                                                placeholder={field.label}
                                                value={shippingAddress[field.name]}
                                                onChange={handleAddressChange}
                                                className='w-full px-3 sm:px-4 py-2.5 sm:py-3 text-sm border border-neutral-300 rounded-lg outline-none focus:border-neutral-900 transition-colors'
                                                style={{ fontFamily: 'Georgia, serif' }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Gift Card Section */}
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg'
                            >
                                <h2 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight flex items-center gap-2'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    <FaGift size={20} className='text-neutral-600' />
                                    Have a Gift Card?
                                </h2>

                                {!appliedGiftCard ? (
                                    <div>
                                        <div className='flex flex-col sm:flex-row gap-2 sm:gap-3 mb-3'>
                                            <input 
                                                type='text'
                                                value={giftCardCode}
                                                onChange={(e) => setGiftCardCode(e.target.value.toUpperCase())}
                                                onKeyPress={(e) => e.key === 'Enter' && validateGiftCard()}
                                                placeholder='Enter gift card code'
                                                maxLength={20}
                                                className='flex-1 px-3 sm:px-4 py-2.5 sm:py-3 text-sm border border-neutral-300 rounded-lg outline-none focus:border-neutral-900 font-mono'
                                                style={{ fontFamily: 'Georgia, serif' }}
                                            />
                                            <button
                                                onClick={validateGiftCard}
                                                disabled={giftCardLoading || !giftCardCode.trim()}
                                                className='px-4 sm:px-6 py-2.5 sm:py-3 text-xs sm:text-sm uppercase tracking-wider font-medium text-neutral-200 bg-neutral-900 border border-neutral-900 rounded-lg transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed'
                                                style={{ fontFamily: 'Georgia, serif' }}
                                            >
                                                {giftCardLoading ? 'Checking...' : 'Apply'}
                                            </button>
                                        </div>
                                        
                                        {giftCardError && (
                                            <div 
                                                className='flex items-start gap-2 p-3 rounded-lg bg-red-50 border border-red-200'
                                            >
                                                <AlertCircle className='w-4 h-4 text-red-600 mt-0.5 flex-shrink-0' />
                                                <p className='text-sm text-red-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    {giftCardError}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div 
                                        className='p-3 sm:p-4 rounded-lg bg-emerald-50 border border-emerald-200'
                                    >
                                        <div className='flex items-start justify-between mb-2 sm:mb-3'>
                                            <div className='flex items-start gap-2'>
                                                <Check className='w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 mt-0.5 flex-shrink-0' />
                                                <div>
                                                    <p className='font-medium text-sm sm:text-base text-emerald-900' 
                                                        style={{ fontFamily: 'Georgia, serif' }}>
                                                        Gift Card Applied
                                                    </p>
                                                    <p className='text-xs sm:text-sm text-emerald-700 font-mono mt-1'
                                                        style={{ fontFamily: 'Georgia, serif' }}>
                                                        {appliedGiftCard.code}
                                                    </p>
                                                </div>
                                            </div>
                                            <button
                                                onClick={removeGiftCard}
                                                className='text-emerald-700 hover:text-emerald-900 transition'
                                            >
                                                <X className='w-4 h-4 sm:w-5 sm:h-5' />
                                            </button>
                                        </div>
                                        
                                        <div className='space-y-1 text-xs sm:text-sm mt-3 pt-3 border-t border-emerald-200'>
                                            <div className='flex justify-between'>
                                                <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    Gift Card Balance:
                                                </span>
                                                <span className='font-medium text-emerald-900'
                                                    style={{ fontFamily: 'Georgia, serif' }}>
                                                    {displayNGNCurrency(appliedGiftCard.currentBalance)}
                                                </span>
                                            </div>
                                            <div className='flex justify-between'>
                                                <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    Applied Amount:
                                                </span>
                                                <span className='font-medium text-emerald-900'
                                                    style={{ fontFamily: 'Georgia, serif' }}>
                                                    -{displayNGNCurrency(appliedGiftCard.applicableAmount)}
                                                </span>
                                            </div>
                                            <div className='flex justify-between pt-1'>
                                                <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                    Remaining Balance:
                                                </span>
                                                <span className='font-medium text-emerald-900'
                                                    style={{ fontFamily: 'Georgia, serif' }}>
                                                    {displayNGNCurrency(appliedGiftCard.remainingBalance)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Payment Methods */}
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg'
                            >
                                <h2 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight flex items-center gap-2'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    <FaCreditCard size={20} className='text-neutral-600' />
                                    Payment Method
                                </h2>

                                <div className='grid sm:grid-cols-3 gap-3 sm:gap-4'>
                                    {[
                                        { id: 'flutterwave', label: 'Flutterwave', icon: '💳', color: 'bg-blue-600 hover:bg-blue-700' },
                                        { id: 'stripe', label: 'Stripe', icon: '🔐', color: 'bg-purple-600 hover:bg-purple-700' },
                                        { id: 'cod', label: 'Cash on Delivery', icon: '🚚', color: 'bg-emerald-600 hover:bg-emerald-700' }
                                    ].map((method) => (
                                        <button
                                            key={method.id}
                                            onClick={() => handlePaymentMethod(method.id)}
                                            disabled={processing}
                                            className={`p-3 sm:p-4 rounded-lg text-neutral-200 font-medium text-sm uppercase tracking-wider transition-all hover:scale-[1.02] disabled:opacity-50 flex flex-col items-center gap-2 ${method.color}`}
                                            style={{ fontFamily: 'Georgia, serif' }}
                                        >
                                            <span className='text-2xl'>{method.icon}</span>
                                            <span className='mt-1'>{method.label}</span>
                                            {processing && <span className='text-xs mt-1'>Processing...</span>}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Order Summary Sidebar */}
                        <div className='mt-8 lg:mt-0 lg:col-span-1'>
                            <div 
                                className='p-4 sm:p-6 border border-neutral-300 bg-white rounded-lg lg:sticky lg:top-28'
                            >
                                <h3 className='text-xl font-normal mb-4 sm:mb-6 text-neutral-900 tracking-tight'
                                    style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                    Order Total
                                </h3>

                                <div className='space-y-3 sm:space-y-4 mb-6 sm:mb-8 pb-6 sm:pb-8 border-b border-neutral-300'>
                                    <div className='flex justify-between text-sm'>
                                        <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                            Subtotal ({cartData.length} items)
                                        </span>
                                        <span className='font-medium text-neutral-900' 
                                            style={{ fontFamily: 'Georgia, serif' }}>
                                            {displayNGNCurrency(subtotal)}
                                        </span>
                                    </div>

                                    <div className='flex justify-between text-sm'>
                                        <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                            Delivery Fee
                                        </span>
                                        <span className='font-medium text-emerald-700' 
                                            style={{ fontFamily: 'Georgia, serif' }}>
                                            {displayNGNCurrency(deliveryFee)}
                                        </span>
                                    </div>

                                    {/* Gift Card Discount Display */}
                                    {appliedGiftCard && (
                                        <div className='flex justify-between text-sm'>
                                            <span className='text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                                Gift Card Discount
                                            </span>
                                            <span className='font-medium text-emerald-700' 
                                                style={{ fontFamily: 'Georgia, serif' }}>
                                                -{displayNGNCurrency(giftCardDiscount)}
                                            </span>
                                        </div>
                                    )}

                                    <div className='pt-3 sm:pt-4 border-t border-neutral-300'>
                                        <div className='flex justify-between text-base sm:text-lg'>
                                            <span className='font-normal text-neutral-900'
                                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                Total Amount:
                                            </span>
                                            <span className='font-normal text-xl sm:text-2xl text-neutral-900'
                                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}>
                                                {displayNGNCurrency(finalTotal)}
                                            </span>
                                        </div>
                                        <p className='text-xs text-neutral-500 mt-1 sm:mt-2' 
                                            style={{ fontFamily: 'Georgia, serif' }}>
                                            Includes all applicable taxes and fees
                                        </p>
                                    </div>
                                    
                                    {/* Savings Indicator */}
                                    {appliedGiftCard && (
                                        <div 
                                            className='p-3 rounded-lg bg-emerald-50 border border-emerald-200 text-center mt-3'
                                        >
                                            <p className='text-xs sm:text-sm font-medium text-emerald-900' 
                                                style={{ fontFamily: 'Georgia, serif' }}>
                                                🎉 You saved {displayNGNCurrency(giftCardDiscount)}!
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* Security Info */}
                                <div 
                                    className='flex items-start gap-2 sm:gap-3 p-3 sm:p-4 rounded-lg bg-neutral-50 border border-neutral-200 mb-4 sm:mb-6'
                                >
                                    <Shield size={16} className='text-neutral-600 mt-0.5 flex-shrink-0' />
                                    <div className='text-xs sm:text-sm text-neutral-600' 
                                        style={{ fontFamily: 'Georgia, serif' }}>
                                        Your payment is secure and encrypted
                                    </div>
                                </div>

                                {/* Shipping Info */}
                                <div 
                                    className='flex items-start gap-2 sm:gap-3 p-3 sm:p-4 rounded-lg bg-neutral-50 border border-neutral-200'
                                >
                                    <Truck size={16} className='text-neutral-600 mt-0.5 flex-shrink-0' />
                                    <div className='text-xs sm:text-sm text-neutral-600' 
                                        style={{ fontFamily: 'Georgia, serif' }}>
                                        Estimated delivery: 3-5 business days
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Bottom Checkout Bar */}
            {cartData.length > 0 && (
                <div className='lg:hidden fixed bottom-0 left-0 right-0 border-t border-neutral-300 bg-white p-4 shadow-lg'>
                    <div className='flex justify-between items-center'>
                        <div>
                            <p className='text-xs text-neutral-600' style={{ fontFamily: 'Georgia, serif' }}>
                                Total:
                            </p>
                            <p 
                                className='font-normal text-base text-neutral-900'
                                style={{ fontFamily: 'Georgia, serif', fontWeight: 400 }}
                            >
                                {displayNGNCurrency(finalTotal)}
                            </p>
                        </div>
                        <button
                            onClick={() => {
                                // Check if all required fields are filled
                                const requiredFields = ['street', 'city', 'state', 'postalCode', 'phoneNumber', 'landmark']
                                const missingFields = requiredFields.filter(field => !shippingAddress[field])
                                
                                if (missingFields.length > 0) {
                                    toast.error(`Please fill in: ${missingFields.join(', ')}`)
                                    return
                                }
                                
                                // Show payment method selection
                                const paymentMethod = window.prompt('Select payment method:\n1. Flutterwave\n2. Stripe\n3. Cash on Delivery', 'flutterwave')
                                if (paymentMethod) {
                                    const methodMap = {
                                        '1': 'flutterwave',
                                        'flutterwave': 'flutterwave',
                                        '2': 'stripe', 
                                        'stripe': 'stripe',
                                        '3': 'cod',
                                        'cod': 'cod'
                                    }
                                    const selectedMethod = methodMap[paymentMethod.toLowerCase()]
                                    if (selectedMethod) {
                                        handlePaymentMethod(selectedMethod)
                                    }
                                }
                            }}
                            className='px-4 sm:px-6 py-2 sm:py-3 text-xs sm:text-sm uppercase tracking-wider font-medium text-neutral-200 bg-neutral-900 border border-neutral-900 rounded-lg transition-all hover:scale-105'
                            style={{ fontFamily: 'Georgia, serif' }}
                            disabled={processing}
                        >
                            {processing ? 'Processing...' : 'Complete Order'}
                        </button>
                    </div>
                </div>
            )}

            {/* Add padding to bottom for mobile checkout bar */}
            <div className='lg:hidden pb-20' />

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                div {
                    animation: fadeIn 0.3s ease-out;
                }
            `}</style>
        </div>
    )
}

export default Checkout;